package ui.external.materialui

object LabelPlacement {
    const val start = "start"
}
